import platform from 'utils/platform';
import { showBiometrics } from 'utils/events';
import { DEV_BIOMETRIC_QUERY_KEY } from 'constants/digitalLoan';

const BIOMETRIC_STORAGE_KEY = 'MLS-Token';

let devBiometricModeSnapshot = null;

/**
 * Captura el modo dev desde la URL una sola vez al entrar al flujo.
 * Sobrevive navegaciones internas que eliminan el query string.
 */
export function snapshotDevBiometricModeFromUrl() {
  if (process.env.NODE_ENV === 'production' || platform.isNativeApp) {
    return;
  }

  if (devBiometricModeSnapshot !== null) {
    return;
  }

  const value = new URLSearchParams(window.location.search).get(DEV_BIOMETRIC_QUERY_KEY);
  devBiometricModeSnapshot = value === 'failure' ? 'failure' : 'success';
}

/** Solo para pruebas. */
export function resetDevBiometricModeSnapshotForTests() {
  devBiometricModeSnapshot = null;
}

/**
 * Modo biométrico para desarrollo en navegador (ignorado en producción y en app nativa).
 * @returns {'success'|'failure'|null}
 */
export function getDevBiometricMode() {
  if (process.env.NODE_ENV === 'production' || platform.isNativeApp) {
    return null;
  }

  snapshotDevBiometricModeFromUrl();
  return devBiometricModeSnapshot;
}

/**
 * Verificación biométrica local del dispositivo sin login ni modificación de token.
 */
export function verifyDeviceBiometric() {
  if (!platform.isNativeApp) {
    const devMode = getDevBiometricMode();
    if (devMode === 'failure') {
      return Promise.reject(new Error('Biometrics verification failed'));
    }
    if (devMode === 'success') {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Biometrics not supported on web'));
  }

  return showBiometrics(BIOMETRIC_STORAGE_KEY).then((response) => {
    if (!response?.token) {
      return Promise.reject(new Error('Biometrics verification failed'));
    }
    return undefined;
  });
}
